import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';

export class HelpButton extends React.Component<{}, {}> {

	public render() {
		return <button className='button help-button' onClick={() => this.openGuide()}>
			<FontAwesomeIcon className='fa-flip-horizontal' icon={faQuestion} />
		</button >
	}

	openGuide() {
		document.body.dispatchEvent(new Event('open-guide'));
	}
}